"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HFlow_1 = require("./HFlow");
Object.defineProperty(exports, "HFlow", { enumerable: true, get: function () { return HFlow_1.HFlow; } });
//# sourceMappingURL=index.js.map